import { AuthResponse } from "types/user";
import { RootStore } from "store";
import { makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";

class UserStore {
	rootStore: RootStore;
	metaData: AuthResponse | null = null;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
		makeAutoObservable(this);
		makePersistable(this, { name: "genius-orders:user-metaData", properties: ["metaData"], storage: window.localStorage });
	}

	setMetaData = (authResponse: AuthResponse) => {
		this.metaData = authResponse;
	};
}

export default UserStore;
